const isProduction = process.env.NODE_ENV === 'production';

// In production, use relative path (empty string) if no URL is provided.
// In development, default to localhost:5000.
export const API_URL = process.env.REACT_APP_API_URL || (isProduction ? '' : 'http://localhost:5000');
